import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { Eyebrow, SectionLabel } from "@/components/Eyebrow";

const SECTIONS = [
  { h: "The DirectConnect promise", b: "Guaranteed admission to UCF for students with an AA — or a state-articulated AS — from one of UCF's partner colleges. The most legible transfer guarantee in the state system." },
  { h: "The 45-credit checkpoint", b: "DirectConnect engagement begins at 45 credits. Earlier than most students realize. Earlier than most advisors mention." },
  { h: "myKnight Audit", b: "UCF's degree-audit tool. How to read it correctly — including what counts as a 'major-applicable' credit versus a credit that articulates but doesn't advance you." },
  { h: "Future Knight Portal & Success Pathways", b: "The structured engagement programs that connect partner-college students to UCF advising, faculty, and major-specific prerequisites." },
  { h: "What guaranteed does not mean", b: "Admission to your major is not guaranteed. Limited-access programs at UCF apply standard departmental review — DirectConnect gets you in the building, not into every classroom in it." },
  { h: "The Transfer Summary Report", b: "The firm's signature DirectConnect-track deliverable. A written audit of your DirectConnect standing, major-applicable credits, prerequisite gaps for limited-access programs, and a 45-to-admit semester plan." },
];

export default function PlaybookUCF() {
  return (
    <Layout>
      <SEO
        title="UCF DirectConnect Playbook — The 45-Credit Checkpoint"
        description="Guaranteed admission to UCF with an AA from a partner college. The 45-credit checkpoint, myKnight Audit, and the fine print on limited-access majors."
        canonical="/playbooks/ucf-directconnect"
        keywords="UCF DirectConnect, UCF transfer, Valencia to UCF, myKnight Audit, UCF partner colleges"
      />
      <section className="border-b border-stone/30 bg-bone" data-testid="playbook-ucf-page">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-20 lg:pt-28 pb-16">
          <div className="mb-6 border-l-2 border-brass pl-4 py-2 text-xs text-ink-soft" data-testid="playbook-ucf-fl-callout">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">Florida Specialization Playbook</div>
            <div className="mt-1">Part of the Beyond Valencia Florida transfer engine. For the current primary flow, see the <a href="/mishap-corrector" className="text-ivy hover:text-brass underline">Mishap Corrector</a>.</div>
          </div>
          <Eyebrow>Florida Specialization Playbook · UCF DirectConnect</Eyebrow>
          <h1 className="font-serif font-medium text-4xl sm:text-5xl lg:text-[4.75rem] text-ink leading-[1.04] tracking-tightest mt-5">
            UCF DirectConnect<br /><span className="italic text-ivy">to UCF.</span>
          </h1>
          <p className="mt-6 text-ink-soft text-base sm:text-lg max-w-2xl leading-relaxed">
            Guaranteed admission. Real terms and real conditions. Read the fine print before the 45th credit.
          </p>
        </div>
      </section>

      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-20 lg:py-24 space-y-12">
        {SECTIONS.map((s, i) => (
          <div key={s.h} className="border-l-2 border-brass pl-5">
            <SectionLabel index={String(i + 1).padStart(2, "0")} label={s.h} />
            <p className="mt-4 text-ink-soft leading-relaxed">{s.b}</p>
          </div>
        ))}
      </article>

      <section className="bg-ivy text-bone py-20 text-center">
        <p className="font-serif font-medium text-2xl sm:text-3xl tracking-tight px-5">Map your DirectConnect path.</p>
        <a href="/transfer-audit" className="inline-block mt-8 bg-brass hover:bg-brass-soft text-ink uppercase tracking-[0.18em] text-xs font-semibold py-4 px-8 transition-colors">Schedule Audit — $249</a>
      </section>
    </Layout>
  );
}
